export default "__VITE_ASSET__Bb8Qxom4__"